<template>
    <el-main class="app_border"  >
        <el-row>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="24">
                <el-carousel :interval="4000" type="card" height="200px" class="sp_imglist">
                    <el-carousel-item v-for="myimg in imgs" >
                        <img :src="myimg" @click="clickImg($event)"/>
                    </el-carousel-item>
                </el-carousel>
            </el-col>
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="24">
                <h1 class="app_title">{{item.sp_name}}</h1>
                <p>应用更新：最后更新于{{item.updatetime}}</p>
                <p>应用安装：{{item.sp_downs}}次</p>
                <p>应用价格：{{item.sp_price}}元</p>
                <p class="contactta" v-if="maijia.qq"><a target="_blank" @click="callqq"">联系卖家[{{maijia.username}}]&nbsp;<i class="el-icon-bell"></i></a></p>
                <el-button  @click="buy(item)" size="mini" type="danger" icon="el-icon-goods">购买</el-button>
            </el-col>

                <img src="../assets/userad.png" class="appinfouserad hidden-sm-and-down"  />


        </el-row>


        <el-menu v-loading="loading" :default-active="activeIndex" class="el-menu-demo app_info_display" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1">应用介绍</el-menu-item>
        <el-menu-item index="2" v-if="item.sp_updatelogtext!=null">更新日志</el-menu-item>
        <el-menu-item index="3" v-if="docfiles.length>0">说明文档</el-menu-item>
        <el-menu-item index="4">用户评论</el-menu-item>
        </el-menu>
        <div v-show="showjieshao">

            <div  ref="showappinfo" class="app_info_show">

            </div>
        </div>
        <div v-show="updatelog">

            <div  ref="showupdatelog">

            </div>
        </div>
        <div v-show="introfiles">

           <ul v-for="item in docfiles" class="app_doc_list">
               <li>
                   <span>{{item.substring(item.lastIndexOf('/')+9)}}</span>

                   <el-button @click="downfile(item)" type="primary" size="mini" class="downit">下载</el-button>
               </li>
           </ul>
        </div>
        <div v-show="showcomment">
            <p>应用综合评分：</p>
            <el-rate
                    v-model="item.sp_rate"
                    disabled
                    show-score
                    text-color="#ff9900"
                    score-template="{value}分">
            </el-rate>

            <ul v-for="(item,index) in commentlist" class="appcommentlist">
                <li>
                    <p>
                        <span class="c_username">{{++index}}楼</span>.
                        <span class="c_username">{{item.username}}</span>.
                        <span class="c_addtime">{{item.addtime}}</span>.
                        <el-rate
                                class="c_rate"
                                v-model="item.rate"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="{value}分">
                        </el-rate>
                    </p>
                    <p>
                        {{item.comment}}
                    </p>
                    <div class="sphuifu" v-if="item.spcomment">
                       商家回复： {{item.spcomment}}
                    </div>
                </li>
            </ul>
            <div v-show="commentapppages!=1&&commentapppages!=0" class="app_loadmore"  @click="getappcommentlist">{{loadingtext}}</div>
        </div>
        <big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>

        <el-dialog
                v-if="this.$store.state.loginstate"
                title="购买信息"
                :visible.sync="centerDialogVisible"
                class="mydialog"
                center>
            <el-form  name="goumaifom" label-width="80px" size="mini" :action="this.$store.state.baseurl + 'appstore/aliapbuyytransfer'" method="post" target="_blank">

                <el-form-item label="应用名称">
                    <b>{{item.sp_name}}</b>
                </el-form-item>
                <el-form-item label="价格(元):">
                    <el-input  disabled v-model="item.sp_price" :value="item.sp_price"></el-input>
                </el-form-item>
                <el-form-item label="接收邮箱">
                    <el-input  type="text" name="receiveemail" v-model="receiveemail"></el-input>
                </el-form-item>
                <el-form-item label="购买备注">
                    <el-input type="textarea" name="beizhu" v-model="beizhu"></el-input>
                </el-form-item>
                <input type="hidden" name="spid" v-model="item.Id" />
                <input type="hidden" name="accesstoken" v-model="this.$store.state.accesstoken" />
                <input type="hidden" name="money" v-model="item.sp_price" />
                <button v-if="item.sp_price>0" @click="checkinput" size="small" class="el-button el-button--primary el-button--small popchonzhibtn" type="button">
                支付宝下单
                </button>
                <button @click="buyfromyue" size="small" class="el-button el-button--danger el-button--small popchonzhibtn" type="button">
                账户余额购买
                </button>
            </el-form>


        </el-dialog>

        <el-dialog
                v-if="this.$store.state.loginstate"
                title="提示"
                :visible.sync="mycenterDialogVisible"
                class="mydialog"
                center>
            <span>如果确认购买成功，请点击确认！</span>
  <span slot="footer" class="dialog-footer">
    <el-button size="small"  @click="mycenterDialogVisible = false">购买失败</el-button>
      <el-button size="small"  type="primary" @click="mycenterDialogVisible = false">购买成功</el-button>
  </span>
        </el-dialog>
       </el-main>
</template>
        <script>
            import axios from 'axios'
            import BigImg from '@/components/BigImg'
            export default{
                name:'ShopInfo',
                        data(){
                    return {
                        loadingtext:'点击加载更多',
                        commentapppages:0,
                        receiveemail:'',
                        beizhu:'',
                        mycenterDialogVisible:false,
                        centerDialogVisible:false,
                        showcomment:false,
                        introfiles:false,
                        updatelog:false,
                        showjieshao:true,
                        showImg:false,
                        imgSrc: '',
                        activeIndex: "1",
                        loading:false,
                         imgs:[],
                        docfiles:[],
                        item:{},
                        maijia:[],
                        commentlist:[],
                       form:{
                           id:0
                       },
                        commentform:{
                            spid:0,
                            accesstoken:'',
                            page:0
                        }
                    }
                },
                components:{
                    'big-img': BigImg
                },
                methods:{
                    callqq(){
                        //'http://wpa.qq.com/msgrd?v=3&uin='+maijia.qq+'&site=qq&menu=yes'
                        var ua=navigator.userAgent;
                        if(ua.match('app/whatsns')){

                            document.location = "whatsns://webview?fun=callqq&qq="+this.maijia.qq;
                        }else{
                            window.open('http://wpa.qq.com/msgrd?v=3&uin='+this.maijia.qq+'&site=qq&menu=yes')
                        }
                    },
                    getappcommentlist(){
                        this.loading = true
                        this.loadingtext = '加载中...'
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        if (_this.commentform.page <= _this.commentapppages) {
                            _this.commentform.accesstoken=this.$store.state.accesstoken
                            if(_this.commentform.page==1){
                                _this.commentform.page=2
                            }
                            _this.commentform.spid=this.item.Id
                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.commentform));
                            axios.post(this.$store.state.baseurl + 'appstore/getappcommentlist', params).then(function (response) {

                                if(response.data.data.length==0){
                                    _this.commentlist=[]
                                    _this.loading = false

                                    _this.loadingtext = ''
                                    return false
                                }


                                response.data.data.forEach(function (val, index) {
                                    _this.commentlist.push(val);
                                    _this.commentapppages =val.pagenums

                                })

                                _this.loading = false
                                if (_this.commentform.page == _this.commentapppages){
                                    _this.loadingtext = '我也是有底线的'
                                }else{
                                    _this.loadingtext = '点击加载更多'
                                }

                                if(_this.commentform.page==2){
                                    _this.commentform.page=3
                                }else{
                                    _this.commentform.page++
                                }
                                // _this.articles = response.data

                            }).catch(function (error) {
                                console.log(error);
                            });
                        }else{

                            _this.loading = false
                            _this.loadingtext = '我也是有底线的'
                        }
                    },
                    checkinput(){
                       if(this.receiveemail==''){
                           this.$message('接收邮箱不能为空，否则无法收到应用文件')
                           return false
                       }
                        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                        if(!reg.test(this.receiveemail)){ //正则验证不通过，格式不对
                            this.$message('邮箱格式错误')
return false;
}
                        this.mycenterDialogVisible=true
                        this.centerDialogVisible=false
                        document.goumaifom.submit();
                    },
                    buyfromyue(){
                        if(this.receiveemail==''){
                            this.$message('接收邮箱不能为空，否则无法收到应用文件')
                            return false
                        }
                        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                        if(!reg.test(this.receiveemail)){ //正则验证不通过，格式不对
                            this.$message('邮箱格式错误')
                            return false;
                        }

                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;
                        //this.centerDialogVisible=false
                        var postdata={
                            spid:_this.item.Id,
                            beizhu:_this.beizhu,
                            receiveemail:_this.receiveemail,
                            accesstoken:_this.$store.state.accesstoken
                        }


                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/buyappinyue', params).then(function (response) {
                            _this.loading = false


                                    if(response.data.match('ok')){
                                        _this.$message(response.data.replace('ok|',''))
                                        _this.centerDialogVisible=false
                                        return false
                                    }
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }




                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    buy(item){
                        if(!this.$store.state.loginstate){
                            this.$store.state.showloginform = true
                            return false
                        }
                        this.centerDialogVisible=true
                    },
                    downfile(item){
                        if(!this.$store.state.loginstate){
                            this.$store.state.showloginform = true
                        }else{
                            window.open(item)

                        }
                    },

                    handleSelect(key)
                    {

                        switch(key){
                            case '1':
                                this.showjieshao=true
                                this.updatelog=false
                                this.introfiles=false
                                this.showcomment=false
                                break;
                            case '2':
                                this.showjieshao=false
                                this.updatelog=true
                                this.introfiles=false
                                this.showcomment=false
                                break;
                            case '3':
                                this.showjieshao=false
                                this.updatelog=false
                                this.introfiles=true
                                this.showcomment=false
                                break;
                            case '4':
                                this.showjieshao=false
                                this.updatelog=false
                                this.introfiles=false
                                this.showcomment=true
                                this.commentform.page=0
                                this.commentlist=[]
                                this.getappcommentlist()
                                break;
                        }

                    },
                clickImg(e) {
                   this.showImg = true;
// 获取当前图片地址
              this.imgSrc = e.currentTarget.src;
},
             viewImg(){
                 this.showImg = false;
        }
                },
                mounted:function(){

                         this.form.id=this.$route.query.id
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;



                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.form));
                            axios.post(this.$store.state.baseurl + 'appstore/getshopinfo', params).then(function (response) {
                                if(response.data==null){
                                    _this.$message('没有该应用信息,或者已经删除');
                                    setTimeout(function(){
                                        _this.$router.push({name:'Index',params:{}})
                                    },2000)
                                    _this.loading = false
                                    return false
                                }
                                console.log(response.data)
                                _this.item=response.data
                                _this.maijia=_this.item.maijia
                                _this.$refs.showappinfo.innerHTML = _this.item.sp_info
                                _this.$refs.showupdatelog.innerHTML = _this.item.sp_updatelogtext
                                if(_this.item.app_imgs)
                                _this.imgs=_this.item.app_imgs.split(',')
                                if(_this.item.app_doc)
                                _this.docfiles=_this.item.app_doc.split(',')
                                _this.loading = false

                            }).catch(function (error) {
                                console.log(error);
                            });


                }
            }
        </script>
<style scoped>
    .el-carousel__container{
        height: 14rem;
    }

    .sp_imglist img{
        max-height: 14rem;
    }
    .el-carousel__item:nth-child(2n) {

    }

    .el-carousel__item:nth-child(2n+1) {

    }
</style>


// WEBPACK FOOTER //
// src/components/ShopInfo.vue